import { render, staticRenderFns } from "./MainCheckbox.vue?vue&type=template&id=e3854684&scoped=true"
import script from "./MainCheckbox.vue?vue&type=script&lang=js"
export * from "./MainCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MainCheckbox.vue?vue&type=style&index=0&id=e3854684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3854684",
  null
  
)

export default component.exports